import axios from 'axios';
import router from '../router'; // 确保导入 Vue Router 实例

let cachedToken = null; // 全局变量来存储token
// 创建 axios 实例
const api = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
// 请求拦截器
api.interceptors.request.use(
  async config => {
    // 检查请求路径是否包含 '/'
    const excludedPaths = ['login', 'usage','privacy','service'];
    if (!excludedPaths.some(path => config.url.includes(path))){
      // 如果缓存的 token 不存在，则从安卓的 AppPreferences 中获取
      if (!cachedToken) {
        try {
          cachedToken = await getTokenFromAppPreferences();
        } catch (error) {
          console.error("Error fetching token:", error);
          router.push({ name: 'Wrong' }); // 定向到错误页面
          return Promise.reject(new Error('Token is missing'));
        }
      }

      // 如果 token 存在，则设置自定义头部 token
      if (cachedToken) {
        config.headers.token = cachedToken;
      } else {
        router.push({ name: 'Wrong' }); // 定向到错误页面
        return Promise.reject(new Error('Token is missing'));
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
  

// 模拟从安卓 AppPreferences 获取 token 的函数
async function getTokenFromAppPreferences() {
  // 这里需要实现从安卓 AppPreferences 获取 token 的逻辑
  // 例如：通过调用安卓接口获取 token
  return new Promise((resolve, reject) => {
    if (window.AndroidInterface && typeof window.AndroidInterface.getToken === 'function') {
      const token = window.AndroidInterface.getToken();
      resolve(token);
      console.log('token:', token);
      
    } else {
      reject('Android interface not available');
    }
    
  });
// return 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxMDAwMTYiLCJpYXQiOjE3MzcwOTAxODEsImV4cCI6MTczNzE3NjU4MX0.OX-_8FcIQvclfPJyUn2wxnz3murDkhqD0VaaESqeCxZXIskEenRv-4BFfNAasqKd9JLX4gYcZM3VfB92Xtz2dw'; // 模拟获取 token
}



export default api;